import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateUserInput, ExtranetUserListItem } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';

export const useCreateUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateUserInput) =>
      getExtranetApi().post<CreateUserInput, ExtranetUserListItem>('/v1/extranet/users', input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['extranet', 'users'] });
    },
  });
};
